export default __webpack_public_path__ + "static/media/115.302a8f3b.jpg";